<template>
    <Sheet v-loading="loading.global">
        <el-tabs value="booking">
            <el-tab-pane label="借用登記(管理者專用)" name="booking" lazy>
                <admin-booking-form :loading="loading.actions['booking']"></admin-booking-form>
            </el-tab-pane>
            <el-tab-pane label="表單紀錄" name="manage" lazy>
                <booking-manage :loading="loading.actions['manage']"></booking-manage>
            </el-tab-pane>
            <el-tab-pane label="人工抽籤" name="draw" lazy>
                <manual-draw :loading="loading.actions['manage']"></manual-draw>
            </el-tab-pane>
            <el-tab-pane label="公告管理" name="news" lazy>
                <news-manage :loading="loading.actions['news']"></news-manage>
            </el-tab-pane>
            <el-tab-pane label="未中籤處理" name="noDrew" lazy>
                <no-drew-manage :loading="loading.actions['manage']"></no-drew-manage>
            </el-tab-pane>
            <el-tab-pane label="中籤結果統計" name="statistic" lazy>
                <drew-statistic :loading="loading.actions['manage']"></drew-statistic>
            </el-tab-pane>
        </el-tabs>
    </Sheet>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import AdminBookingForm from './AdminBookingForm';
    import BookingManage from './BookingManage';
    import ManualDraw from './ManualDraw';
    import NewsManage from './NewsManage';
    import NoDrewManage from './NoDrewManage';
    import DrewStatistic from './DrewStatistic';
    export default {
        name: 'manage',
        components:{
            AdminBookingForm,
            BookingManage,
            ManualDraw,
            NewsManage,
            NoDrewManage,
            DrewStatistic
        },
        computed:{
            ...mapState(['loading']),
        },
        async created() {

        }
    }
</script>

<style>

</style>